const ITEMS = [
  "Vocal Mechanics",
  "Executive Presence",
  "Investor Pitch Coaching",
  "Breath & Resonance",
  "Articulation & Clarity",
  "Composure Under Pressure",
  "Vocal Stamina & Projection",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section data-testid="editorial-marquee" aria-hidden="true" className="overflow-hidden border-y border-[#26282E]/10 bg-[#E3D9C8] py-6">
      <div className="animate-marquee flex w-max items-center gap-16 whitespace-nowrap pr-16">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-16">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-16">
                <span className={i % 2 === 0 ? "font-serif text-xl italic text-[#5B5E66]" : "font-mono text-[11px] uppercase tracking-[0.3em] text-[#2F5D8C]/90"}>
                  {item}
                </span>
                <span className="h-1 w-1 rounded-md bg-[#2F5D8C]/50" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
